import { render, staticRenderFns } from "./DashboardItem.vue?vue&type=template&id=3ca346d0&scoped=true"
import script from "./DashboardItem.vue?vue&type=script&lang=js"
export * from "./DashboardItem.vue?vue&type=script&lang=js"
import style0 from "./DashboardItem.vue?vue&type=style&index=0&id=3ca346d0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca346d0",
  null
  
)

export default component.exports